import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { ApiToStoreCallsService } from '../../../services';
import {
  loadSuppliers,
  loadSuppliersFailure,
  loadSuppliersSuccess,
} from '../actions/suppliers.actions';

@Injectable()
export class SuppliersEffects {
  constructor(
    private actions$: Actions,
    private apiService: ApiToStoreCallsService,
  ) {}

  loadSuppliers$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(loadSuppliers),
      switchMap(() => this.apiService.getSuppliers()),
      map((suppliers) => loadSuppliersSuccess({ suppliers })),
      catchError(() => of(loadSuppliersFailure())),
    );
  });
}
